// Deterministic signature of the verified comparable set a pricing result
// was calculated from. The backend computes the same value when generating
// (functions/pricingStrategy/compSetSignature.js - keep the two identical; a
// test enforces it) so a recommendation is never silently shown against a
// different comparable set than the one it was calculated with.

function normalizeAddress(address) {
  return String(address || "").toLowerCase().replace(/[^a-z0-9#]+/g, " ").replace(/\s+/g, " ").trim();
}

export function computeCompSetSignature(comps) {
  const entries = (Array.isArray(comps) ? comps : [])
    .filter((c) => c && c.isStructured === true && c.address)
    .map((c) => `${normalizeAddress(c.address)}|${String(c.soldDate || "").slice(0, 10)}${c.agentReview && c.agentReview.included ? "|agent" : ""}`)
    .sort();
  let hash = 5381;
  const text = entries.join(";");
  for (let i = 0; i < text.length; i += 1) hash = ((hash * 33) ^ text.charCodeAt(i)) >>> 0;
  return `${entries.length}:${hash.toString(16)}`;
}
